export default __webpack_public_path__ + "static/media/navyFederal.ab560e83.svg";